import actionTypes from './../constants/actionTypes';

const initialState = {
    listing: {},
    chartData: {},
};

export const homeReducer = (state = initialState, action) => {
    try {
        const { type, payload, status } = action;
        switch (type) {
            case actionTypes.HOME.TRACKING_LIST: {
                return {
                    ...state,
                    listing: payload
                }
            }
            case actionTypes.HOME.TRACKING_CHART_DATA: {
                return {
                    ...state,
                    chartData: payload
                }
            }
        }
        return state;
    } catch (error) {
        return state;
    }
}
export default homeReducer;
